import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "web-use-flex" }
const _hoisted_2 = { class: "context" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("h2", null, [
  /*#__PURE__*/_createElementVNode("span", { id: "reg-login" }, "1.1 Sign-up/Sign-in")
], -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("p", null, " Please sign up/sign in in the upper right corner of the DEC official website. ", -1)
const _hoisted_5 = /*#__PURE__*/_createStaticVNode("<p><a name=\"_Toc27584\"><span><span><span><b><span>Sign-up: </span></b></span></span></span></a><b><span>：</span></b><span>You can sign up with the mobile phone number or email address.</span></p><p><a name=\"_Toc28762\"><span><span><span><b><span>Sign-in</span></b></span></span></span></a><b><span>：</span></b></p><p><span>If you use a DEC account signed up with an email address/mobile phone number, you can sign in to the service through the [Account + verification code] or [Account + password].</span></p><h2><a id=\"user-center\"><span><span><span><span><span>1.2 </span></span></span></span></span></a><span>Personal Center</span></h2><p><span>After sign-in, you can enter at the &quot;avatar&quot; in the upper right corner of the website.</span></p>", 5)
const _hoisted_10 = /*#__PURE__*/_createElementVNode("h3", null, [
  /*#__PURE__*/_createElementVNode("a", { id: "user-center-1" }, [
    /*#__PURE__*/_createElementVNode("span", null, [
      /*#__PURE__*/_createElementVNode("span", null, [
        /*#__PURE__*/_createElementVNode("span", null, [
          /*#__PURE__*/_createElementVNode("span", null, [
            /*#__PURE__*/_createElementVNode("span", null, "1.2.1 ")
          ])
        ])
      ])
    ])
  ]),
  /*#__PURE__*/_createElementVNode("span", null, "Personal Information")
], -1)
const _hoisted_11 = /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createElementVNode("span", null, "Personal information includes the nickname (which can be modified), the sign-up way you selected [mobile phone number or email address], your invitation code, and points you have earned.")
], -1)
const _hoisted_12 = /*#__PURE__*/_createElementVNode("h3", null, [
  /*#__PURE__*/_createElementVNode("a", { id: "user-center-2" }, [
    /*#__PURE__*/_createElementVNode("span", null, [
      /*#__PURE__*/_createElementVNode("span", null, [
        /*#__PURE__*/_createElementVNode("span", null, [
          /*#__PURE__*/_createElementVNode("span", null, [
            /*#__PURE__*/_createElementVNode("span", null, "1.2.2 ")
          ])
        ])
      ])
    ])
  ]),
  /*#__PURE__*/_createElementVNode("span", null, "Order Information")
], -1)
const _hoisted_13 = /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createElementVNode("span", null, "This page shows the balance, orders, bills, and points of your account.")
], -1)
const _hoisted_14 = /*#__PURE__*/_createElementVNode("h3", null, [
  /*#__PURE__*/_createElementVNode("a", null, [
    /*#__PURE__*/_createElementVNode("span", null, "1.2.2.1")
  ]),
  /*#__PURE__*/_createElementVNode("span", null, "Gift Service")
], -1)
const _hoisted_15 = /*#__PURE__*/_createElementVNode("p", null, "（1）Authentication", -1)
const _hoisted_16 = /*#__PURE__*/_createElementVNode("p", null, " ①　In section 1, you can enter the account you want to give the service to, and click \"send verification code\". ", -1)
const _hoisted_17 = /*#__PURE__*/_createElementVNode("p", null, " ②　In section 2, you can enter the verification code received by the email / mobile phone number bound to service account you gift to. ", -1)
const _hoisted_18 = /*#__PURE__*/_createElementVNode("p", null, "③　Click “Next” to enter authentication.", -1)
const _hoisted_19 = /*#__PURE__*/_createElementVNode("p", null, "（2）Gift Service", -1)
const _hoisted_20 = /*#__PURE__*/_createElementVNode("p", null, " ①　In section 1, you can enter the number of months you want to give away, and click \"Send verification code\". ", -1)
const _hoisted_21 = /*#__PURE__*/_createElementVNode("p", null, " ②　In section 2, you can enter the verification code received by the email / mobile number bound to your account. ", -1)
const _hoisted_22 = /*#__PURE__*/_createElementVNode("p", null, "③　Click “Confirm” to complete the giving away service.", -1)
const _hoisted_23 = /*#__PURE__*/_createElementVNode("h3", null, [
  /*#__PURE__*/_createElementVNode("a", null, [
    /*#__PURE__*/_createElementVNode("span", null, "1.2.2.2")
  ]),
  /*#__PURE__*/_createElementVNode("span", null, "Redeem Rewards")
], -1)
const _hoisted_24 = /*#__PURE__*/_createElementVNode("p", null, "1. You can redeem for Free Trail/Pro services in \"Rewards.\"", -1)
const _hoisted_25 = /*#__PURE__*/_createElementVNode("p", null, " 2. You can earn points by inviting your friends to register DEC account, purchasing services, or increasing your daily authorized devices, etc. The specific method of earning points and the corresponding reward points can be viewed in the upper right corner of the Rewards. ", -1)
const _hoisted_26 = /*#__PURE__*/_createStaticVNode("<p> 3. The Free trial cannot be redeemed with DEC Accounts that already have an active Pro version service. The Pro services cannot be redeemed with DEC Accounts that already have a Trail version service. You can redeem these rewards after your current service has expired. </p><h3><a id=\"user-center-3\"><span><span><span><span><span>1.2.3 </span></span></span></span></span><span>Setting/Modifying Password</span></a></h3><p><span>You can modify the password based on the sign-up way you selected [mobile phone number or email address].</span></p><h2><a id=\"pay\"><span><span><span><span><span>1.3</span></span></span></span></span></a><span>Purchasing Service</span></h2><h3><a id=\"pay-1\"><span>1.3.1</span></a><span>Pro Edition Service</span></h3><p><a name=\"_Toc8297\"><span>(1) DEC official website - Plans, click the “Get Pro” to purchase the service.</span></a><span>。</span></p>", 6)
const _hoisted_32 = /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createElementVNode("span", null, "(2) Service Selection")
], -1)
const _hoisted_33 = /*#__PURE__*/_createElementVNode("p", null, " In Section 1, it shows the specific price for purchasing the service with different sets per month. ", -1)
const _hoisted_34 = /*#__PURE__*/_createElementVNode("p", null, " In Section 2, it shows the unit price per set per month of the current purchase quantity and the V code input box. ", -1)
const _hoisted_35 = /*#__PURE__*/_createElementVNode("p", null, " In Section 3, it shows the adjustable purchase quantity and the required amount of money for the current purchase quantity. ", -1)
const _hoisted_36 = /*#__PURE__*/_createElementVNode("p", null, "In Section 4, it shows the payment methods.", -1)
const _hoisted_37 = /*#__PURE__*/_createElementVNode("p", null, "(3) Paypal payment", -1)
const _hoisted_38 = /*#__PURE__*/_createElementVNode("p", null, "(4) Payment successful", -1)
const _hoisted_39 = /*#__PURE__*/_createElementVNode("p", null, " You have access to the service through clicking “View the Order” or clicking “Download the DEC Hub”. ", -1)
const _hoisted_40 = /*#__PURE__*/_createElementVNode("h3", null, [
  /*#__PURE__*/_createElementVNode("a", { id: "pay-2" }, [
    /*#__PURE__*/_createElementVNode("span", null, [
      /*#__PURE__*/_createElementVNode("span", null, [
        /*#__PURE__*/_createElementVNode("span", null, [
          /*#__PURE__*/_createElementVNode("span", null, [
            /*#__PURE__*/_createElementVNode("span", null, "1.3.2 ")
          ])
        ])
      ])
    ])
  ]),
  /*#__PURE__*/_createElementVNode("span", null, "Enterprise Edition Service")
], -1)
const _hoisted_41 = /*#__PURE__*/_createElementVNode("p", null, "(1) DEC official website - Plans, click“Contact Us”.", -1)
const _hoisted_42 = /*#__PURE__*/_createElementVNode("p", null, "(2) Please fill in the enterprise information, major business, etc.", -1)
const _hoisted_43 = /*#__PURE__*/_createElementVNode("p", null, " (3) After filling in the information, please click“Confirm”. After the information is submitted, the platform staff will contact you as soon as possible. ", -1)
const _hoisted_44 = /*#__PURE__*/_createElementVNode("h2", null, [
  /*#__PURE__*/_createElementVNode("a", { id: "download-dec" }, [
    /*#__PURE__*/_createElementVNode("span", null, [
      /*#__PURE__*/_createElementVNode("span", null, [
        /*#__PURE__*/_createElementVNode("span", null, [
          /*#__PURE__*/_createElementVNode("span", null, [
            /*#__PURE__*/_createElementVNode("span", null, "1.4 ")
          ])
        ])
      ])
    ])
  ]),
  /*#__PURE__*/_createElementVNode("span", null, "Downloading the DEC Hub")
], -1)
const _hoisted_45 = /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createElementVNode("b", null, [
    /*#__PURE__*/_createElementVNode("span", null, "Downloading ways:")
  ])
], -1)
const _hoisted_46 = /*#__PURE__*/_createElementVNode("p", null, " 1. You can download the DEC Hub in the upper right corner of the official website; ", -1)
const _hoisted_47 = /*#__PURE__*/_createElementVNode("p", null, " 2. Plans - Free Experience, click the “Free Experience” to download the DEC Hub. ", -1)
const _hoisted_48 = /*#__PURE__*/_createElementVNode("p", null, "It can only be downloaded after sign-in.", -1)


export default /*#__PURE__*/_defineComponent({
  __name: 'WebUseEn',
  setup(__props) {

const imageList = {
  image1: require("../../assets/en-document-images/c766b3fed5654234bfc71d8d1cede7ff.jpg"),
  image2: require("../../assets/en-document-images/54741bd04ff14b6b8351a9fe87decfc3.jpg"),
  image3: require("../../assets/en-document-images/acf6e169a1694012b0b30efc536598b7.jpg"),
  image4: require("../../assets/en-document-images/0221d3de0dd94605875c751e4a017818.jpg"),
  image5: require("../../assets/en-document-images/1cd838aac4ff4aa8be5150fdcf2be2a3.jpg"),
  image6: require("../../assets/en-document-images/2722ae5d94004613a1591ecdd3e6635c.jpg"),
  image7: require("../../assets/en-document-images/f84cce6e52b440b0896c38edba9041c0.jpg"),
  image8: require("../../assets/en-document-images/ac480f8147fd44b8bdf3ef256e527174.jpg"),
  image9: require("../../assets/en-document-images/1c722ebb36214ac9afef106f875b0b56.jpg"),
  image10: require("../../assets/en-document-images/6f199df701e24cf29bcba4cc18038578.jpg"),
  image11: require("../../assets/en-document-images/682cc569eff54bdb80d151faa385ba6d.png"),
  image12: require("../../assets/en-document-images/d98f5fdfb891405d87f83f41967ea80b.jpg"),
  image13: require("../../assets/en-document-images/gfit1.jpg"),
  image14: require("../../assets/en-document-images/gfit2.jpg"),
  image15: require("@/assets/en-document-images/en-reward1.jpg"),
  image16: require("@/assets/en-document-images/en-reward2.jpg"),
};

return (_ctx: any,_cache: any) => {
  const _component_el_image = _resolveComponent("el-image")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _hoisted_4,
      _createElementVNode("p", null, [
        _createElementVNode("span", null, [
          _createVNode(_component_el_image, {
            src: imageList.image1,
            "preview-src-list": [imageList.image1],
            fit: "contain"
          }, null, 8, ["src", "preview-src-list"])
        ])
      ]),
      _hoisted_5,
      _createElementVNode("p", null, [
        _createElementVNode("span", null, [
          _createVNode(_component_el_image, {
            src: imageList.image2,
            "preview-src-list": [imageList.image2],
            fit: "contain"
          }, null, 8, ["src", "preview-src-list"])
        ])
      ]),
      _hoisted_10,
      _createElementVNode("p", null, [
        _createElementVNode("span", null, [
          _createVNode(_component_el_image, {
            src: imageList.image3,
            "preview-src-list": [imageList.image3],
            fit: "contain"
          }, null, 8, ["src", "preview-src-list"])
        ])
      ]),
      _hoisted_11,
      _hoisted_12,
      _hoisted_13,
      _createElementVNode("p", null, [
        _createElementVNode("span", null, [
          _createVNode(_component_el_image, {
            src: imageList.image4,
            "preview-src-list": [imageList.image4],
            fit: "contain"
          }, null, 8, ["src", "preview-src-list"])
        ])
      ]),
      _hoisted_14,
      _createElementVNode("p", null, [
        _createVNode(_component_el_image, {
          src: imageList.image13,
          "preview-src-list": [imageList.image13],
          fit: "contain"
        }, null, 8, ["src", "preview-src-list"])
      ]),
      _hoisted_15,
      _hoisted_16,
      _hoisted_17,
      _hoisted_18,
      _createElementVNode("p", null, [
        _createVNode(_component_el_image, {
          src: imageList.image14,
          "preview-src-list": [imageList.image14],
          fit: "contain"
        }, null, 8, ["src", "preview-src-list"])
      ]),
      _hoisted_19,
      _hoisted_20,
      _hoisted_21,
      _hoisted_22,
      _hoisted_23,
      _createElementVNode("p", null, [
        _createVNode(_component_el_image, {
          src: imageList.image15,
          "preview-src-list": [imageList.image15],
          fit: "contain"
        }, null, 8, ["src", "preview-src-list"])
      ]),
      _hoisted_24,
      _hoisted_25,
      _createElementVNode("p", null, [
        _createVNode(_component_el_image, {
          src: imageList.image16,
          "preview-src-list": [imageList.image16],
          fit: "contain"
        }, null, 8, ["src", "preview-src-list"])
      ]),
      _hoisted_26,
      _createElementVNode("p", null, [
        _createElementVNode("span", null, [
          _createVNode(_component_el_image, {
            src: imageList.image5,
            "preview-src-list": [imageList.image5],
            fit: "contain"
          }, null, 8, ["src", "preview-src-list"])
        ])
      ]),
      _hoisted_32,
      _createElementVNode("p", null, [
        _createElementVNode("span", null, [
          _createVNode(_component_el_image, {
            src: imageList.image6,
            "preview-src-list": [imageList.image6],
            fit: "contain"
          }, null, 8, ["src", "preview-src-list"])
        ])
      ]),
      _hoisted_33,
      _hoisted_34,
      _hoisted_35,
      _hoisted_36,
      _hoisted_37,
      _createElementVNode("p", null, [
        _createElementVNode("span", null, [
          _createVNode(_component_el_image, {
            src: imageList.image8,
            "preview-src-list": [imageList.image8],
            fit: "contain"
          }, null, 8, ["src", "preview-src-list"])
        ])
      ]),
      _hoisted_38,
      _createElementVNode("p", null, [
        _createElementVNode("span", null, [
          _createVNode(_component_el_image, {
            src: imageList.image9,
            "preview-src-list": [imageList.image9],
            fit: "contain"
          }, null, 8, ["src", "preview-src-list"])
        ])
      ]),
      _hoisted_39,
      _hoisted_40,
      _hoisted_41,
      _createElementVNode("p", null, [
        _createElementVNode("span", null, [
          _createVNode(_component_el_image, {
            src: imageList.image10,
            "preview-src-list": [imageList.image10],
            fit: "contain"
          }, null, 8, ["src", "preview-src-list"])
        ])
      ]),
      _hoisted_42,
      _createElementVNode("p", null, [
        _createElementVNode("span", null, [
          _createVNode(_component_el_image, {
            src: imageList.image11,
            "preview-src-list": [imageList.image11],
            fit: "contain"
          }, null, 8, ["src", "preview-src-list"])
        ])
      ]),
      _hoisted_43,
      _hoisted_44,
      _createElementVNode("p", null, [
        _createElementVNode("span", null, [
          _createVNode(_component_el_image, {
            src: imageList.image12,
            "preview-src-list": [imageList.image12],
            fit: "contain"
          }, null, 8, ["src", "preview-src-list"])
        ])
      ]),
      _hoisted_45,
      _hoisted_46,
      _hoisted_47,
      _hoisted_48
    ])
  ]))
}
}

})